import { formatLeaveType,formatToLongDate } from "../../../../../utils/helpers.ts";

function resolveEmployeeDisplayName(item: {
  fullName?: string | null;
  rawData?: { name?: string | null; employeeId?: number | null };
}): string {
  const candidates = [item.fullName, item.rawData?.name];
  for (const v of candidates) {
    if (typeof v === "string" && v.trim() !== "") return v.trim();
  }
  return "Employee";
}

function formatLeaveDetail(raw: {
  startDate?: string;
  endDate?: string;
  noOfDays?: number | null;
}): string {
  const startDate = raw?.startDate;
  const endDate = raw?.endDate ?? startDate;
  const noOfDays = Number(raw?.noOfDays);
  if (noOfDays === 1) return formatToLongDate(startDate);
  return `${formatToLongDate(startDate)} to ${formatToLongDate(endDate)}`;
}

export const formatData = (apiData: any[]) => {
  return apiData.map((item) => {
    const isLeave = item.type === "LEAVE";

    return {
      id: item.id,
      name: resolveEmployeeDisplayName(item),

      type:
        item.type === "LEAVE"
          ? "leave"
          : item.type === "ACCESS"
            ? "access"
            : item.type === "ASSET"
              ? "asset"
              : item.type === "TIMESHEET"
                ? "timesheet"
                : item.type === "REIMBURSEMENT"
                  ? "reimbursement"
                  : "asset",

      summary: isLeave
        ? formatLeaveType(item.rawData?.typeOfLeave)
        : null,  

      detail: isLeave
        ? formatLeaveDetail(item.rawData)
        : item.rawData?.reason || "Request",

     
      badge: isLeave
        ? formatLeaveType(item.rawData?.typeOfLeave)
        : item.type,
    };
  });
};